<script setup lang="ts">
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import type { ProductSmartFilterDetail } from '~/types/api'

const props = defineProps<{
  smartFilter?: ProductSmartFilterDetail | null
}>()

const router = useRouter()
const route = useRoute()
const localePath = useLocalePath()

const breakpoints = useBreakpoints(breakpointsTailwind)
const invertButton = computed(() => {
  if (!props.smartFilter?.description && props.smartFilter?.image) {
    return false
  } else if (props.smartFilter?.description && !props.smartFilter?.image) {
    return true
  }
  return breakpoints.greaterOrEqual('xl').value
})
</script>

<template>
  <section
    v-if="props.smartFilter?.image || props.smartFilter?.description"
    class="container pb-16"
  >
    <div
      class="relative grid grid-cols-1 bg-black text-white"
      :class="{
        'xl:grid-cols-2':
          props.smartFilter?.image && props.smartFilter?.description,
      }"
    >
      <div v-if="props.smartFilter?.image" class="overflow-hidden">
        <NuxtImg
          :alt="props.smartFilter?.image?.metaAlt || undefined"
          :title="props.smartFilter?.image?.metaTitle || undefined"
          sizes="600px md:700px lg:1000px"
          class="h-0 min-h-72 w-full object-cover"
          :class="{
            'xl:!min-h-full': props.smartFilter?.description,
          }"
          :src="withHost(smartFilter?.image?.url ?? '')"
          loading="lazy"
        />
      </div>
      <div
        v-if="props.smartFilter?.description"
        class="p-10 text-left text-sm selection:bg-white selection:text-black xl:min-h-72 xl:p-20 2xl:px-32"
        :class="{
          '!py-20': !props.smartFilter?.image,
        }"
        v-html="props.smartFilter?.description"
      ></div>
      <ClientOnly>
        <ProductsFiltersChip
          removable
          class="absolute right-6 top-6"
          :invert="invertButton"
          :clickable="false"
          :title="props.smartFilter?.title || ''"
          @remove="
            router.push(localePath({ name: 'products', query: route.query }))
          "
        />
      </ClientOnly>
    </div>
  </section>
</template>
